import * as React from 'react';

import {Nut_WebFx_Mcfx_Enrichment_Actions_GetAccountEnrichmentData as SettingsConstants} from 'nutshell-core/settings-constants';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {ToggleableSection} from 'shells/layout/toggleable-section';
import {LoadingPage} from 'shells/loading-page/loading-page';
import {Body} from 'shells/typography/body';

import {useUpdateSetting} from '../../core/use-update-setting';
import {PageContainer, PageTitleBar} from '../../layout';

import {PeopleIqSettings} from './people-iq-settings';
import {useGetPeopleIqSettings} from './use-get-people-iq-settings';

export const IS_PEOPLE_IQ_DISABLED = 'is_people_iq_disabled';

export function PeopleIqPage() {
    const {isNutshellIntelligenceDisabled, isPeopleIqDisabled, isLoading} =
        useGetPeopleIqSettings();

    const updateSetting = useUpdateSetting();

    const title = 'Nutshell Intelligence & PeopleIQ';

    return (
        <PageContainer
            title={title}
            pageTitleBar={
                <PageTitleBar
                    title={title}
                    subheaderPrimaryText='Fine-tune your Nutshell experience by configuring profile enrichment, company information retrieval, and PeopleIQ recommendation preferences.'
                />
            }
        >
            {isLoading ? (
                <LoadingPage />
            ) : (
                <StackLegacy spacing={16}>
                    <ToggleableSection
                        title='Nutshell Intelligence'
                        subtitle='Gathers information about people and companies in Nutshell.'
                        isOn={!isNutshellIntelligenceDisabled}
                        onToggle={() => {
                            updateSetting({
                                settingName:
                                    SettingsConstants.NUTSHELL_INTELLIGENCE_DISABLED_SETTING_NAME,
                                value: !isNutshellIntelligenceDisabled,
                                isGlobal: true,
                            });
                        }}
                        content={
                            <Body size='small' color='light'>
                                {isNutshellIntelligenceDisabled
                                    ? 'Nutshell Intelligence is disabled. To get additional information about the people and companies in Nutshell, please enable this feature.'
                                    : 'Nutshell Intelligence is enabled. When visiting a company page, or a person page containing an email address or phone number, Nutshell will display a pop-up notification in the top right corner if additional information is available.'}
                            </Body>
                        }
                    />
                    <ToggleableSection
                        title='PeopleIQ'
                        subtitle='PeopleIQ expands its search to identify individuals employed at companies within your target market. Select the specific roles you’re interested in, and Nutshell will retrieve names, titles, phone numbers, and email addresses, streamlining your outreach efforts.'
                        isOn={!isPeopleIqDisabled}
                        onToggle={() => {
                            updateSetting({
                                settingName: IS_PEOPLE_IQ_DISABLED,
                                value: !isPeopleIqDisabled,
                                isGlobal: true,
                            });
                        }}
                        content={
                            isPeopleIqDisabled ? (
                                <Body size='small' color='light'>
                                    PeopleIQ is currently disabled. To activate notifications and
                                    gain access to our filtering tools for refining your recommended
                                    contacts, please enable this feature.
                                </Body>
                            ) : (
                                <PeopleIqSettings />
                            )
                        }
                    />
                </StackLegacy>
            )}
        </PageContainer>
    );
}
